<template>
  <com-page>
    <com-card>
      <dateSelect @on-date="handleData" @on-export="handleExport"></dateSelect>
    </com-card>
    <com-card class="mt-15px">
      <com-table ref="table" :columns="columns" :api="api"></com-table>
    </com-card>
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils'
import { userStatistics } from '@/api/statistics'
import dateSelect from './components/the-time-select'

export default {
  components: { dateSelect },
  data() {
    return {
      api: userStatistics,
      columns: [
        {
          label: '日期',
          prop: 'date'
        },
        {
          label: '新增',
          prop: 'newUser'
        },
        {
          label: '充电人数',
          prop: 'chargeNumber'
        },
        {
          label: '充值人数',
          prop: 'rechargeNumber'
        },
        {
          label: '购买月卡人数',
          prop: 'monthCardNumber'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleData(val) {
      this.query = val
      this.$refs.table.search(val)
    },
    async handleExport() {
      try {
        this.$message.info('正在导出请稍后')
        const query = {
          ...this.query,
          pageIndex: 1,
          pageSize: 10000
        }
        const {
          data: { records }
        } = await userStatistics(query)
        const newArr = []
        records.forEach((item) => {
          const param = {
            日期: item.date,
            新增: item.newUser,
            充电人数: item.chargeNumber,
            充值人数: item.rechargeNumber,
            购买月卡人数: item.monthCardNumber
          }
          newArr.push(param)
        })
        exportExcel(newArr, '用户数据分析')
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
